import React from 'react';
import { MapContainer, TileLayer, CircleMarker, Popup } from 'react-leaflet';
import { Stockist } from '../data/siteContent';
type Props = {
  stockists: (Stockist & {
    region: string;
  })[];
  center: [number, number];
  zoom: number;
};

/**
 * Leaflet map of stockist locations.
 * Uses CircleMarkers in brand colours rather than pin image assets.
 */
export function StockistMap({
  stockists,
  center,
  zoom
}: Props) {
  return <div className="h-[520px] w-full overflow-hidden rounded-4xl border border-oat/70" data-id="element-239" data-mp="20cjv87wgmm6w">
      <MapContainer key={`${center[0]}-${center[1]}-${zoom}`} center={center} zoom={zoom} scrollWheelZoom={false} className="h-full w-full" data-id="element-240" data-mp="1vk0i1c1opt2m">
        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" data-id="element-241" data-mp="1ml6gd79hyci7" />
        {stockists.map(s => <CircleMarker key={s.name} center={[s.lat, s.lng]} radius={9} pathOptions={{
        color: '#3B302F',
        weight: 2,
        fillColor: '#432C47',
        fillOpacity: 0.9
      }} data-id="element-242" data-mp="1coadbh2dail1">
            <Popup data-id="element-243" data-mp="2hxa28wx9ct5r">
              <span className="type-ui block text-sm text-coffee" data-id="element-244" data-mp="2mujqwactp0sj">
                {s.name}
              </span>
              <span className="type-body block text-xs text-ink/60" data-id="element-245" data-mp="3ake44t120rdb">
                {s.address}
              </span>
              <span className="type-eyebrow mt-1 block text-[9px] text-pennant" data-id="element-246" data-mp="3elzmuv09rzvf">
                {s.region}
              </span>
            </Popup>
          </CircleMarker>)}
      </MapContainer>
    </div>;
}